"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _requiredActions = require("./required-actions.constants");

var _requiredActions2 = require("./requiredActions.shape");

var _ChooseCalendar = _interopRequireDefault(require("./components/ChooseCalendar"));

var ACTIONS_WITH_TEXTFIELD = [_requiredActions.CAPTURE_QUESTION, _requiredActions.CAPTURE_AFFIDAVIT];

var buttonClasses = function buttonClasses(palette) {
  return {
    enabled: {
      color: palette.common.white,
      bgColor: palette.green.dark,
      hoverColor: palette.common.white,
      hoverBgColor: palette.green.mountainMeadowLight
    },
    disabled: {
      borderColor: palette.grey.regular
    }
  };
};

var RequiredActions = function RequiredActions(_ref) {
  var isLoading = _ref.isLoading,
      actions = _ref.actions,
      locked = _ref.locked,
      handleChangeField = _ref.handleChangeField,
      changeProspectBulk = _ref.changeProspectBulk,
      errors = _ref.errors;

  var _useTheme = (0, _material.useTheme)(),
      palette = _useTheme.palette;

  var giftHasProspect = !!Object.values(actions).reduce(function (hasProspect, value) {
    return value || hasProspect;
  });

  var _useState = (0, _react.useState)(giftHasProspect),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      prospectIsOpened = _useState2[0],
      setProspectIsOpened = _useState2[1];

  var hasTextField = R.flip(R.includes)(ACTIONS_WITH_TEXTFIELD);
  var getTextFieldName = R.pipe(R.split('_'), R.last, R.concat('gifter_'));
  var getCustomComponent = R.cond([[R.equals(_requiredActions.CAPTURE_DATE), R.always(_ChooseCalendar.default)], [R.T, R.always(null)]]);

  var _useMemo = (0, _react.useMemo)(function () {
    var classes = [buttonClasses(palette).enabled, buttonClasses(palette).disabled];
    if (prospectIsOpened) return classes;
    return classes.reverse();
  }, [prospectIsOpened, palette]),
      _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 2),
      openButtonClass = _useMemo2[0],
      closeButtonClass = _useMemo2[1];

  var handleClose = (0, _react.useCallback)(function () {
    setProspectIsOpened(false);
    changeProspectBulk();
  }, [changeProspectBulk]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column"
  }, !locked && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    mt: 1,
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 3,
    mr: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.BaseButton, (0, _extends2.default)({
    onClick: handleClose
  }, closeButtonClass), "No")), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_ui.BaseButton, (0, _extends2.default)({
    onClick: function onClick() {
      setProspectIsOpened(true);
    }
  }, openButtonClass, {
    disabled: locked
  }), "Yes"))), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: prospectIsOpened
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, _requiredActions.REQUIRED_ACTIONS.map(function (action, index) {
    var hasAreaField = hasTextField(action.id);
    var textFieldName = hasAreaField ? getTextFieldName(action.id) : '';
    var textFieldValue = hasAreaField ? actions[textFieldName] : '';
    var actionValue = actions[action.id];
    var CustomComponent = getCustomComponent(action.id);
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: action.id,
      ml: 3,
      mt: 1,
      mb: 1
    }, !!index && /*#__PURE__*/_react.default.createElement(_material.Box, {
      pt: 1,
      pb: 1
    }, /*#__PURE__*/_react.default.createElement(_ui.Divider, {
      my: 1
    })), /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
      disabled: locked || isLoading,
      control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
        checked: actionValue,
        onChange: function onChange(event, value) {
          return handleChangeField(action.id, value);
        },
        value: action.id,
        color: "primary"
      }),
      label: /*#__PURE__*/_react.default.createElement(_material.Typography, {
        className: locked ? '' : 'Body-Regular-Left-Static-Bold'
      }, action.title)
    }), /*#__PURE__*/_react.default.createElement(_material.Box, {
      pl: 4
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: "Body-Regular-Left-Static"
    }, action.description)), CustomComponent && /*#__PURE__*/_react.default.createElement(_material.Box, {
      pt: 1,
      pl: 4
    }, /*#__PURE__*/_react.default.createElement(CustomComponent, {
      actionValue: actionValue,
      onActionChange: function onActionChange(value) {
        return handleChangeField(action.id, value);
      }
    })), hasAreaField && /*#__PURE__*/_react.default.createElement(_material.Box, {
      pt: 1,
      pl: 4
    }, /*#__PURE__*/_react.default.createElement(_ui.TextAreaField, {
      name: textFieldName,
      fullWidth: true,
      value: textFieldValue,
      onChange: function onChange(event) {
        return handleChangeField(textFieldName, event.target.value);
      },
      errors: errors,
      disabled: locked || isLoading || !actions[action.id]
    })));
  }))));
};

RequiredActions.propTypes = {
  actions: _propTypes.default.shape({
    prospect: _requiredActions2.requiredActionsShape,
    locked: _propTypes.default.bool.isRequired,
    source: _propTypes.default.string.isRequired
  }),
  handleChangeField: _propTypes.default.func.isRequired,
  changeProspectBulk: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool,
  locked: _propTypes.default.bool,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object
};
RequiredActions.defaultProps = {
  actions: {},
  isLoading: false,
  locked: false,
  errors: {}
};
var _default = RequiredActions;
exports.default = _default;